import { render, staticRenderFns } from "./CoAdminMembersBase.vue?vue&type=template&id=78bdf88c&scoped=true&"
import script from "./CoAdminMembersBase.vue?vue&type=script&lang=ts&"
export * from "./CoAdminMembersBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bdf88c",
  null
  
)

export default component.exports